document.addEventListener('DOMContentLoaded', function () {

  
  // Function to initialize Swiper
  function initializeSwiper(section) { 
    const slidesMobile = parseFloat(section.getAttribute('data-slides-mobile'), 10) || 2;
    const slidesDesktop = parseFloat(section.getAttribute('data-slides-desktop'), 10) || 4;
    const spaceBetweenMobile = parseFloat(section.getAttribute('data-space-between-mobile'), 10) || 2;
    const spaceBetweenDesktop = parseFloat(section.getAttribute('data-space-between-desktop'), 10) || 2;
    const autoplay = section.getAttribute('data-auto-scroll') === 'true';

    const nextBtn = section.querySelector('.swiper-button-next'); 
    const prevBtn = section.querySelector('.swiper-button-prev');

    console.log(slidesMobile, slidesDesktop, spaceBetweenMobile, spaceBetweenDesktop, autoplay);

    const swiperInstance = new Swiper(section, {
        slidesPerView: slidesDesktop,
        spaceBetween: spaceBetweenDesktop,
        // simulateTouch: true,
        mousewheel: {
            forceToAxis: true, // Swipes only in the axis of movement
            sensitivity: 1, // Adjust for finer or coarser control
        },
        autoplay: autoplay ? { 
            delay: 50, // Continuous scrolling (no delay between slides)

            // pauseOnMouseEnter: true
        } : false,
        speed: autoplay ? 4650 : 1000, // Adjust scrolling speed for smoothness
        // freeMode: true, // Enable free mode for smooth scrolling
        loop: autoplay ? true : false, // Enable loop mode
        breakpoints: {
            320: {
                slidesPerView: slidesMobile,
                spaceBetween: spaceBetweenMobile,
            },
            1040: {
                slidesPerView: slidesDesktop,
                spaceBetween: spaceBetweenDesktop,
            }
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        pagination: {
            el: section.querySelector('.swiper-pagination'),
            type: 'progressbar', // Enables the progress bar
        },
    });

    if (autoplay) {
      let paused = false; // Track whether autoplay is paused manually
      let currentTranslate = 0; // Store the exact current position
    
      section.addEventListener('mouseenter', () => {
        if (paused) return; // Prevent multiple triggers
        paused = true;
    
        // Get the real-time transform value
        const matrix = window.getComputedStyle(swiperInstance.wrapperEl).transform;
        currentTranslate = matrix !== 'none' ? parseFloat(matrix.split(',')[4]) : 0;
    
        swiperInstance.autoplay.stop(); // Stop autoplay
        swiperInstance.wrapperEl.style.transition = 'none'; // Disable ongoing transitions
        swiperInstance.setTranslate(currentTranslate); // Freeze slider at exact position
    
        console.log('Paused autoplay and froze slider at position:', currentTranslate);
      });
    
      section.addEventListener('mouseleave', () => {
        if (!paused) return; // Prevent multiple triggers
        paused = false;
    
        // // Manually restart transitions
        // swiperInstance.wrapperEl.style.transition = ''; // Restore transitions to default
    
        // console.log('Resuming autoplay from position:', currentTranslate);
    
        // // Apply manual adjustments to transition and transform
        // setTimeout(() => {
        //   swiperInstance.wrapperEl.style.transitionDuration = '50ms';
        //   swiperInstance.wrapperEl.style.transform = `translate3d(${currentTranslate}px, 0px, 0px)`; 
        // }, 50);
    
        // // Gradually adjust transition duration to ensure smooth scrolling
        // setTimeout(() => {
        //   swiperInstance.wrapperEl.style.transitionDuration = '4650ms';
        //   swiperInstance.wrapperEl.style.transform = `translate3d(${currentTranslate + 1}px, 0px, 0px)`;
        // }, 100);
    
        // Restart autoplay after transitions are reset
        setTimeout(() => {
          swiperInstance.autoplay.start(); // Ensure autoplay restarts
          console.log('Autoplay restarted');
        }, 150);
      });
    }
    

    return swiperInstance;
  }

  function lightGalleryInit() {
    const expandImageButtons = document.querySelectorAll('.expand-image-btn');

    if (expandImageButtons.length > 0) {
        // Create the lightbox element
        const lightbox = document.createElement('div');
        lightbox.id = 'lightbox';
        lightbox.innerHTML = '<div class="lightbox-content"><div class="loader"></div><img src="" alt="Expanded Image" style="display: none;"/><button id="close-lightbox" style="display: none;">&times;</button></div>';
        document.body.appendChild(lightbox);

        const lightboxImg = lightbox.querySelector('img');
        const closeButton = lightbox.querySelector('#close-lightbox');
        const loader = lightbox.querySelector('.loader');

        // Add event listeners to buttons
        expandImageButtons.forEach(button => {
            button.addEventListener('click', function() {
                const imgSrc = button.getAttribute('data-img-src');
                if (imgSrc) {
                    loader.style.display = 'block';
                    lightboxImg.style.display = 'none';
                    closeButton.style.display = 'none';
                    lightboxImg.src = imgSrc;
                    lightbox.style.display = 'flex';
                }
            });
        });

        // Handle image load
        lightboxImg.addEventListener('load', function() {
            loader.style.display = 'none';
            lightboxImg.style.display = 'block';
            closeButton.style.display = 'block';
        });

        // Add event listener to close button
        closeButton.addEventListener('click', function() {
            lightbox.style.display = 'none';
            lightboxImg.src = '';
        });

        // Close the lightbox when clicking outside the image
        lightbox.addEventListener('click', function(e) {
            if (e.target === lightbox) {
                lightbox.style.display = 'none';
                lightboxImg.src = '';
            }
        });
    }
  }

  function initializeSwipers() {
    const sections = document.querySelectorAll('.swiper-container');
    sections.forEach(section => {
      if (section.swiper) section.swiper.destroy();
      initializeSwiper(section);
      section.style.opacity = 1;
    });
  }

  function initializeVideoControls() {

    const videoContainers = document.querySelectorAll('.banner__media--video');

    videoContainers.forEach(container => {
      const video = container.querySelector('video');
      const muteToggle = container.querySelector('.mute-toggle');
      const playPauseToggle = container.querySelector('.play-pause-toggle');
  
      if (video && muteToggle && playPauseToggle) {
        // Set initial state for play/pause button
        playPauseToggle.setAttribute('data-state', video.paused ? 'paused' : 'playing');
  
        // Set initial state for mute button
        muteToggle.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');
  
        // Toggle mute/unmute
        muteToggle.addEventListener('click', function() {
          video.muted = !video.muted;
          muteToggle.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');
        });
  
        // Toggle play/pause
        playPauseToggle.addEventListener('click', function() {
          if (video.paused) {
            video.play();
            playPauseToggle.setAttribute('data-state', 'playing');
          } else {
            video.pause();
            playPauseToggle.setAttribute('data-state', 'paused');
          }
        });
  
        // Sync play/pause state when the video is manually played or paused
        video.addEventListener('play', () => playPauseToggle.setAttribute('data-state', 'playing'));
        video.addEventListener('pause', () => playPauseToggle.setAttribute('data-state', 'paused'));
      }
    });
  }

  function sortOverlapSections() {
    const overlaySections = document.querySelectorAll('.banner--overlap');

    overlaySections.forEach(section => {
      const overlayContent = section.querySelector('.banner__box');
      let paddingBottom = parseInt(section.getAttribute('data-padding-bottom')) || 0;

      // if mobile, paddingBottom is 40
      if (window.innerWidth < 768) {
        paddingBottom = 20;
        
      }
      


      // get height of overlay content
      const overlayContentHeight = overlayContent.offsetHeight;

      // set section margin bottom to negative height of overlay content

      console.log(paddingBottom);

      section.style.marginBottom = `${(overlayContentHeight - 65) + paddingBottom }px`;
    })
  }

  function seachModal() {

    const seachInput = document.querySelector('#Search-In-Modal');

    // if search input is focused then add focused class to seach-modal

    seachInput.addEventListener('focus', function() {
      document.querySelector('.search-modal').classList.add('focused');
    });

    seachInput.addEventListener('blur', function() {
      document.querySelector('.search-modal').classList.remove('focused');
    });

  }

  function popup() {
    const popups = document.querySelectorAll('.popup');
    const popupBtns = document.querySelectorAll('.popup-btn');
    const body = document.body;

    // Add click event listeners for popup buttons
    popupBtns.forEach(btn => {
        btn.addEventListener('click', function(event) {
            event.stopPropagation(); // Prevent triggering the document click event
            const btnId = btn.getAttribute('id');

            const needsContent = btn.getAttribute('data-page');

            if (needsContent) {
              console.log('needs content');
              buildContent(needsContent);
           
            }else{
              console.log('no content');

            }

       

            popups.forEach(popup => {
                if (popup.getAttribute('id') === btnId) {
                    popup.classList.add('active');
                    body.classList.add('popup-open'); // Lock body scrolling

                    // Force scroll to top after a short delay (for animation to settle)
                    const popupInner = popup.querySelector('.popup__inner');
                    if (popupInner) {
                        setTimeout(() => {
                            popupInner.scrollTop = 0;
                        }, 50); // Small delay ensures it's applied after animation
                    }
                }
            });
        });
    });

    // Add event listener to close popup when clicking outside popup__inner
    document.addEventListener('click', function(event) {
        popups.forEach(popup => {
          const popupInner = popup.querySelector('.popup__inner');
          const lightbox = document.querySelector('#lightbox');
          
          if (
              popup.classList.contains('active') &&
              popupInner &&
              !popupInner.contains(event.target) &&
              !(lightbox && (lightbox === event.target || lightbox.contains(event.target)))
          ) {
              popup.classList.remove('active');
              body.classList.remove('popup-open'); // Unlock body scrolling
          }
        });
    });

    // Prevent closing when clicking inside the popup__inner
    popups.forEach(popup => {
        const popupInner = popup.querySelector('.popup__inner');
        if (popupInner) {
            popupInner.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent triggering the document click event
            });

            // Close popup when clicking on .popup__close button inside .popup__inner
            const popupCloseBtn = popupInner.querySelector('.popup__close');
            if (popupCloseBtn) {
                popupCloseBtn.addEventListener('click', function(event) {

                    console.log('close button clicked');
                    popup.classList.remove('active');
                    body.classList.remove('popup-open'); // Unlock body scrolling
                });
            }
        }
    });


  function buildContent(data){
    console.log(data);



    //data is a url to a page, featch the content and add it to the popup

    fetch(`/pages/${data}`)
    .then(response => response.text())
    .then(data => {

      //just get element "main" from the page
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const mainContent = doc.querySelector('main');
      console.log(mainContent);
      console.log(data);
      console.log(document.querySelector('.popup__inner.active'));
      document.querySelector('.popup.active .popup__content').innerHTML = mainContent.innerHTML;
      
      // Reinitialize swipers after content is loaded
      setTimeout(() => {
        const popupSwipers = document.querySelectorAll('.popup.active .swiper-container');
        popupSwipers.forEach(section => {
          if (section.swiper) section.swiper.destroy();
          initializeSwiper(section);
          section.style.opacity = 1;
        });
        
        // Also reinitialize other components that might be in the popup content
        lightGalleryInit();
        formatGalleryTable();
      }, 100); // Small delay to ensure DOM is updated
    });

  }
}


function formatGalleryTable() {
  document.querySelectorAll(".customer-gallery-popup__table .metafield-rich_text_field").forEach(container => {
    const paragraphs = Array.from(container.querySelectorAll("p"));
    const wrapper = document.createElement("div");
    wrapper.classList.add("metafield-wrapper");

    let currentItem = null;

    paragraphs.forEach((p) => {
      if (p.textContent.trim() === "") {
        // Empty <p> starts a new item
        currentItem = null;
      } else {
        if (!currentItem) {
          // Create a new item
          currentItem = document.createElement("div");
          currentItem.classList.add("item");
          wrapper.appendChild(currentItem);

          // Create title div (first paragraph is bold)
          const titleDiv = document.createElement("div");
          titleDiv.classList.add("title");
          titleDiv.innerHTML = p.innerHTML;
          currentItem.appendChild(titleDiv);

          // Create content div
          const contentDiv = document.createElement("div");
          contentDiv.classList.add("content");
          currentItem.appendChild(contentDiv);
        } else {
          // Append additional content to the existing item
          const contentDiv = currentItem.querySelector(".content");
          if (contentDiv.innerHTML.trim() === "") {
            // First entry—no <br>
            contentDiv.innerHTML = p.innerHTML;
          } else {
            // Subsequent entries—add <br>
            contentDiv.innerHTML += "<br>" + p.innerHTML;
          }
        }
      }
    });

    container.innerHTML = ""; // Clear existing content
    container.appendChild(wrapper); // Append new structure
  });
}

function customerGalleryNav() {

  const navItems = document.querySelectorAll('.customer-gallery-nav__item');
  const galleryCards = document.querySelectorAll('.cutomer-gallery__card');
  const navWrap = document.querySelector('.customer-gallery-nav__wrap');
  const prevBtn = document.querySelector('.customer-gallery-nav__btn--prev');
  const nextBtn = document.querySelector('.customer-gallery-nav__btn--next');
  const buttonsContainer = document.querySelector('.customer-gallery-nav__buttons');
  const scrollIndicator = document.querySelector('.customer-gallery-nav__scroll-indicator');

  // Function to update button states and custom scrollbar
  function updateButtonStates() {
    if (!navWrap || !prevBtn || !nextBtn || !buttonsContainer) return;
    
    const isAtStart = navWrap.scrollLeft <= 1; // Small tolerance for precision
    const isAtEnd = navWrap.scrollLeft >= (navWrap.scrollWidth - navWrap.clientWidth - 1);
    
    // Always show buttons, but disable when appropriate
    buttonsContainer.style.display = 'flex';
    prevBtn.disabled = isAtStart;
    nextBtn.disabled = isAtEnd;

    // Update custom scrollbar indicator
    updateScrollIndicator();
  }

  // Function to update custom scrollbar progress indicator
  function updateScrollIndicator() {
    if (!navWrap || !scrollIndicator) return;

    const scrollableWidth = navWrap.scrollWidth - navWrap.clientWidth;
    const scrollPercentage = scrollableWidth > 0 ? (navWrap.scrollLeft / scrollableWidth) : 0;
    
    // Calculate available track width (container width minus button space)
    const containerWidth = navWrap.parentElement.clientWidth;
    const buttonSpace = window.innerWidth >= 750 ? 180 : 114; // Responsive button space
    const trackWidth = containerWidth - buttonSpace;
    const indicatorWidth = (trackWidth * scrollPercentage);

    // Show/hide indicator based on whether scrolling is needed
    if (navWrap.scrollWidth > navWrap.clientWidth) {
      scrollIndicator.style.opacity = '1';
      scrollIndicator.style.width = `${Math.min(trackWidth, Math.max(0, indicatorWidth))}px`;
    } else {
      scrollIndicator.style.opacity = '0';
      scrollIndicator.style.width = '0px';
    }
  }

  // Handle scroll buttons
  if (navWrap && prevBtn && nextBtn) {
    const scrollAmount = 200; // Adjust scroll distance as needed

    prevBtn.addEventListener('click', function() {
      navWrap.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      navWrap.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Update button states on scroll and resize
    navWrap.addEventListener('scroll', updateButtonStates);
    window.addEventListener('resize', updateButtonStates);
    
    // Initial button state and scrollbar indicator update
    setTimeout(updateButtonStates, 200); // Small delay to ensure proper calculation
    
    // Force initial indicator update
    setTimeout(updateScrollIndicator, 250);
  }

  // Existing filter functionality
  navItems.forEach(item => {
    item.addEventListener('click', function() {
 
      navItems.forEach(item => {
        item.classList.remove('active');
      });

      item.classList.add('active');
      
      // Smooth scroll to the gallery section, accounting for padding
      const gallerySection = document.querySelector('.cutomer-gallery');
      if (gallerySection) {
        const computedStyle = window.getComputedStyle(gallerySection);
        const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
        const rect = gallerySection.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = rect.top + scrollTop + paddingTop;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }

      const filter = item.getAttribute('data-galley-category').toLowerCase();

      console.log(filter);

      galleryCards.forEach(card => {
        const cardCategory = card.getAttribute('data-categories').toLowerCase();

        if (filter === 'all') {
          card.style.display = 'block';
        } else {
          if (cardCategory.includes(filter)) {
            card.style.display = 'block';
          } else {
            card.style.display = 'none';
          }
        }

      });




    });
  });
}


function initVatToggle() {


  if (window.Shopify && window.Shopify.country) {
    if (window.Shopify.country == "GB") {
      const vatToggles = document.querySelectorAll('.vat-toggle input');
      const vatGlobal = localStorage.getItem('vatToggle') === 'true';
    
      function updateVatState(isChecked) {
        localStorage.setItem('vatToggle', isChecked ? 'true' : 'false');
    
        document.body.classList.toggle('vat-toggle-active', isChecked);
    
        // // Update all price elements
        // document.querySelectorAll('.js-price-vat').forEach(el => {
        //   el.textContent = isChecked ? 'Including VAT' : '';
        //   console.log('added vat inc')
        // });
    
        // Sync all toggle inputs
        vatToggles.forEach(toggle => {
          toggle.checked = isChecked;
        });
    
        console.log(`VAT toggled ${isChecked ? 'on' : 'off'}`);
      }
    
      // Apply the stored VAT state on load
      updateVatState(vatGlobal);
    
      // Listen for changes on all toggles
      vatToggles.forEach(toggle => {
        toggle.addEventListener('change', function () {
          updateVatState(this.checked);
        });
      });
    }else {
   
      document.body.classList.add('non-uk');
  
    }
    
  } 




}

// Run the function on page load
document.addEventListener('DOMContentLoaded', initVatToggle);







  
  



  // Initialize SVGs and Swipers on page load

  initializeSwipers();
  initializeVideoControls();
  sortOverlapSections();
  lightGalleryInit();
  seachModal()
  popup()
  formatGalleryTable()
  customerGalleryNav()
  initVatToggle()

  

  // Shopify Customizer Event Listener for Switching Layouts
  document.addEventListener('shopify:section:load', function() {
    initializeSwipers();
    sortOverlapSections();
  });

  document.addEventListener('shopify:block:select', function() {
    initializeSwipers();
    sortOverlapSections();
  });


  
});




